import React, { useState, useEffect } from 'react';
import { useNavigate, createSearchParams, useLocation } from 'react-router-dom';
import { showNotification } from '@mantine/notifications';
import {
  Center,
  Image,
  SimpleGrid,
  Card,
  Space,
  Paper,
  Group,
  Modal,
  Stack,
  Radio,
  ActionIcon,
  NumberInput,
  Text,
  Title,
  Button,
  RadioGroup,
  Box,
  Container,
  Loader,
} from '@mantine/core';
import dayjs from 'dayjs';
import { IconX } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import idConfig from '../../services/idConfig';

import PrimaryButton from '../../components/GroupButton';
import trolley from '../../image/trolley.svg';
import carWash from '../../image/car-wash.svg';
import shuttled from '../../image/bus.svg';
import quickServices from '../../image/quick-services.svg';
import quickService from '../../image/empty.svg';
import parkingLock from '../../image/emptyPark.svg';
import rentCar from '../../image/emptyRent.svg';
// import servicesApi from '../../services/services';
import { sendRequest, sendRequestWithToken } from '../../services/services';

const App = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation();

  const searchParams = new URLSearchParams(search);
  const VasQty = searchParams.get('vas_qty');
  const PassId = searchParams.get('passId');
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState(1 || parseInt(VasQty, 10));
  // const handlers = useRef<NumberInputHandlers>();
  const [serviceData, setServiceData] = useState([]);

  const [ticketData, setTicketData] = useState();
  const [vasId, setVasId] = useState();
  const [vasSubTypeId, setVasSubTypeId] = useState();
  const [, setVasName] = useState([]);
  const [vasPrice, setVasPrice] = useState();
  const [filteredVas, setFilteredVas] = useState([]);
  const [checked, setChecked] = useState('0');
  const [, setAllService] = useState([]);
  const [matchVas, setMatchVas] = useState([]);
  const [buttonEnable, setButtonEnable] = useState(false);
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));
  const [isLoading, setIsLoading] = useState(false); // Add isLoading state

  const queryParam = `?long=${siteDetails?.long}&lat=${siteDetails?.lat}`;
  useEffect(() => {
    setIsLoading(true);
    sendRequestWithToken(`sites/${siteDetails?.siteId}/${queryParam}`, 'get')
      .then((res) => {
        if (res?.code === 20) {
          setServiceData(res || []);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <IconX size={16} />,
          });
        }
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false after fetching data
      });
  }, [queryParam, vasId]);

  useEffect(() => {
    sendRequest(`sites/vas/list`, 'get').then((res) => {
      setAllService(res || []);
      if (res === 'empty') {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX />,
        });
      }
    });
  }, []);

  useEffect(() => {
    sendRequest(`parking/reservations-by-pass-id/${PassId}`, 'get').then((res) => {
      if (res?.code === 20) {
        setTicketData(res?.data || []);
      } else if (res?.code === 21) {
        showNotification({
          title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
          icon: <IconX size={16} />,
        });
      }
    });
  }, [PassId]);

  const increment = () => {
    setValue((prevCount) => prevCount + 1);
  };

  const decrement = () => {
    setValue((prevCount) => {
      if (prevCount > 1) {
        return prevCount - 1;
      }
      return prevCount;
    });
  };

  const description = () => {
    switch (vasId) {
      case idConfig.VAS_TYPE_TROLLEY:
        return 'trolley';
      case idConfig.VAS_TYPE_SHUTTLE:
        return 'shuttle';
      case idConfig.VAS_TYPE_CARWASH:
        return 'carwash';
      case idConfig.VAS_TYPE_QUICK_SERVICE:
        return 'quickServices';
      default:
        return null;
    }
  };

  const titleVasTypeName = () => {
    switch (vasId) {
      case idConfig.VAS_TYPE_TROLLEY:
        return <Title order={3}>{t('choose.service.trolly.description')}</Title>;
      case idConfig.VAS_TYPE_SHUTTLE:
        return <Title order={3}>{t('choose.service.shuttle.description')}</Title>;
      case idConfig.VAS_TYPE_CARWASH:
        return <Title order={3}>{t('choose.service.carwash.description')}</Title>;
      case idConfig.VAS_TYPE_QUICK_SERVICE:
        return <Title order={3}>{t('choose.service.quickService.description')}</Title>;
      default:
        return null;
    }
  };

  const now = dayjs();
  const serviceBooking = () => {
    let Vas = {
      reservation_id: Number(ticketData?.result?.id),
      site_id: Number(siteDetails?.siteId),
      status_id: 1,
      vehicle_id: Number(ticketData?.result?.vehicles?.id),
      qty: value,
      vas_type_id: Number(vasId),
      vas_sub_type_id: Number(vasSubTypeId),
      desc: description(),
      amount: vasPrice,
      start_time: now,
    };

    const existingVas = JSON.parse(localStorage.getItem('selectedVas'));
    const filtererdVas = !existingVas ? Vas : existingVas.filter((d) => vasId !== d.vas_Id);
    Vas = existingVas ? [Vas, ...filtererdVas] : [Vas];
    localStorage.setItem('selectedVas', JSON.stringify(Vas));
    navigate({
      pathname: '/userDetails',
      search: createSearchParams({
        passId: PassId,
      }).toString(),
    });
  };

  useEffect(() => {
    const grouped = _.mapValues(_.groupBy(serviceData?.data?.site_vas, 'id'), (item) =>
      item.map((car) => _.omit(car, 'id')),
    );

    setFilteredVas(grouped);
  }, [serviceData?.data?.site_vas]);

  const siteVasData = new Map(serviceData?.data?.site_vas?.map((o) => [o.id, o]));

  useEffect(() => {
    const matchedValue = siteVasData;

    setMatchVas([...matchedValue]);
  });

  return (
    <>
      <Box style={{ height: 'calc(100vh - 24px)', marginTop: '24px' }}>
        <Stack justify="space-between" style={{ height: '100%' }}>
          <Box>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
              }}
            >
              <PrimaryButton />
            </Container>
          </Box>
          <Box style={{ flexGrow: '1' }}>
            <Container
              className="home"
              style={{
                display: 'flex',
                alignItems: 'stretch',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <Box
                className="no-printme"
                style={{
                  height: 'fit-content',
                  marginBottom: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: '1',
                  justifyContent: 'space-between',
                }}
              >
                <Stack>
                  <Title style={{ color: '#2C5864', margin: '1% 0' }} order={3}>
                    {t('choose.other.service.text')}
                  </Title>
                </Stack>
                {isLoading ? (
                  <SimpleGrid
                    cols={matchVas.length < 3 ? matchVas.length : matchVas.length / 2}
                    spacing="sm"
                    style={{ height: '100%' }}
                  >
                    <Center>
                      <Paper
                        className="grid-element"
                        style={{
                          height: '100%',
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          placeItems: 'center',
                        }}
                        shadow="sm"
                        p="sm"
                        radius="sm"
                      >
                        <Group position="apart">
                          <Loader />
                          <Title>Loading</Title>
                        </Group>
                      </Paper>
                    </Center>
                  </SimpleGrid>
                ) : (
                  <SimpleGrid
                    cols={matchVas.length < 3 ? matchVas.length : matchVas.length / 2}
                    spacing="sm"
                    style={{ height: '100%' }}
                  >
                    {serviceData?.data?.site_vas.length > 0 ? null : (
                      <Center>
                        <Paper
                          className="grid-element"
                          style={{
                            height: '100%',
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            placeItems: 'center',
                          }}
                          shadow="sm"
                          p="sm"
                          radius="sm"
                        >
                          <Title order={1}>No Service Available</Title>
                        </Paper>
                      </Center>
                    )}
                    {matchVas?.map((item) => (
                      <Paper
                        className="grid-element"
                        style={{
                          height: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          placeItems: 'center',
                        }}
                        key={item.id}
                        shadow="sm"
                        p="sm"
                        radius="sm"
                        onClick={() => {
                          if (item?.id === 24 || 2 || 3) {
                            setOpened(true);
                            setVasId(item[1]?.id);
                            setVasName(item[1]?.vas_types);
                          }
                        }}
                      >
                        <Stack align="center" spacing="sm">
                          <Center>
                            {item[1].id === '24' ? <Image src={carWash} height={80} /> : null}
                            {item[1].id === '2' ? <Image src={trolley} height={80} /> : null}
                            {item[1].id === '3' ? <Image src={shuttled} height={80} /> : null}
                            {item[1].id === '28' ? <Image src={quickService} height={80} /> : null}
                            {item[1].id === '5' ? <Image src={parkingLock} height={80} /> : null}
                            {item[1].id === '7' ? <Image src={rentCar} height={80} /> : null}
                            {item[1].id === '144' ? (
                              <Image src={quickServices} height={80} />
                            ) : null}
                          </Center>

                          <Center>
                            <Text
                              weight={500}
                              style={{ marginBottom: 5, marginTop: 5, textAlign: 'center' }}
                            >
                              {item[1]?.vas_types}: {item[1]?.vas_sub_type_name}
                              <Space v="xl" />
                              {item[1].vas_price} {t('ticket.amount.sar')}
                            </Text>
                          </Center>
                        </Stack>
                      </Paper>
                    ))}
                  </SimpleGrid>
                )}
              </Box>
            </Container>
          </Box>
        </Stack>
      </Box>
      <Modal
        size="lg"
        radius="md"
        centered
        opened={opened}
        overlayOpacity={0.55}
        overlayBlur={3}
        onClose={() => {
          setButtonEnable(false);
          setOpened(false);
          setChecked('');
        }}
        title={titleVasTypeName()}
      >
        <Stack>
          {filteredVas[Number(vasId)]?.map((item) => (
            <Card
              shadow="none"
              radius="md"
              px="lg"
              py="md"
              style={{ width: '100%', marginTop: '3px', backgroundColor: '#F6F6F6' }}
            >
              <Group position="apart" grow>
                <RadioGroup
                  color="green"
                  onChange={() => setChecked(item?.vas_sub_type_id)}
                  value={checked}
                  onClick={() => {
                    setVasSubTypeId(item?.vas_sub_type_id);
                    setVasPrice(item?.vas_price);
                    setButtonEnable(true);
                  }}
                >
                  <Radio
                    value={item?.vas_sub_type_id}
                    label={<Text>{item?.vas_sub_type_name}</Text>}
                  />
                </RadioGroup>
                <Stack style={{ alignItems: 'end' }}>
                  {checked === item?.vas_sub_type_id ? (
                    <Group spacing={2}>
                      <ActionIcon
                        size={42}
                        color="teal"
                        variant="filled"
                        onClick={() => decrement()}
                        disabled={value === 1}
                        style={{ backgroundColor: '#FC3261' }}
                      >
                        –
                      </ActionIcon>

                      <NumberInput
                        hideControls
                        value={value || parseInt(VasQty, 10)}
                        onChange={(val) => setValue(val)}
                        // handlersRef={handlers}
                        max={10}
                        min={1}
                        step={2}
                        styles={{ input: { width: 48, height: 42, textAlign: 'center' } }}
                      />
                      <ActionIcon
                        size={42}
                        color="teal"
                        variant="filled"
                        onClick={() => increment()}
                        style={{ backgroundColor: '#50A847' }}
                      >
                        +
                      </ActionIcon>
                    </Group>
                  ) : (
                    ''
                  )}

                  <Text size="lg">
                    {item?.vas_price} {t('ticket.amount.sar')}
                  </Text>
                </Stack>
              </Group>
            </Card>
          ))}

          <Button
            variant="filled"
            color="teal"
            radius="lg"
            fullWidth
            size="xl"
            onClick={serviceBooking}
            disabled={buttonEnable === false}
            style={{ marginTop: '14px', backgroundColor: buttonEnable ? '#50A847' : '#50a84799' }}
          >
            <Title order={3}>{t('confirm.button.text')}</Title>
          </Button>
        </Stack>
      </Modal>
    </>
  );
};

export default App;
